import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Icon, Dropdown, Button, Loader } from "semantic-ui-react";
import { TitleCase } from "../../common";
import ControlTitle from "../ControlTitle";
import { bindActionCreators } from "redux";
import ReactModal from "react-modal";
import { connect } from "react-redux";
import * as AppActions from "../../actions";
import _ from "lodash";
const uuidv4 = require("uuid/v1");

const customStyles = {
  content: {
    top: "50%",
    maxWidth: "700px",
    width: "85%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0px;",
    borderRadius: "5px",
    backgroundColor: "transparent",
    height: "85%",
    border: "0px",
    transform: "translate(-50%, -50%)"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  }
};

class LookupField extends Component {
  constructor() {
    super();
    this.state = {
      LookupData: [],
      selectedValue: "",
      optionsData: [],
      gotLookup: false,
      isFocused: false,
      categoryFilterStage: 0,
      visible: false,
      cancel: false,
      salesforceType: false,
      loading: false,
      filterText: ""
    };
  }

  componentWillMount() {
    const { ...formControl } = this.props;

    var datasource = _.filter(this.props.datasource, {
      datasource_id: formControl.element_params.Ds
    });

    if (datasource.length === 0) {
      this.setState({ gotLookup: true });
    } else {
      if (datasource[0].direct === 1) {
        //salesforce ms dynamics
        this.setState({ salesforceType: true });
      } else {
        let initialLookupData = [];
        var optionsDataInit = [];

        initialLookupData = _.filter(this.props.lookupData, {
          datasourceId: datasource[0].datasource_id
        });

        initialLookupData[0].lookupData.forEach(element => {
          optionsDataInit.push({
            text: TitleCase(element[formControl.element_params.Fk]),
            value: element._id
          });
        });

        var val = "";
        if (this.props.element_value !== "") {
          val = _.filter(optionsDataInit, { value: this.props.element_value });
          if (val.length > 0) {
            val = val[0].value;
          } else {
            val = "";
          }
        }

        this.setState({
          optionsData: optionsDataInit,
          selectedValue: val,
          LookupData: initialLookupData[0].lookupData,
          gotLookup: true
        });
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const different =
      this.props.element_value !== nextProps.element_value ||
      this.props.isConnected !== nextProps.isConnected ||
      this.state.categoryFilterStage !== nextState.categoryFilterStage ||
      this.state.cancel !== nextState.cancel ||
      this.state.visible !== nextState.visible ||
      this.state.LookupData !== nextState.LookupData ||
      this.state.selectedValue !== nextState.selectedValue ||
      this.props.error !== nextProps.error ||
      this.props.validate !== nextProps.validate;
    return different;
  }

  handleChangeDD(e, d) {
    const { ...formControl } = this.props;

    if (
      this.state.categoryFilterStage === 0 ||
      this.state.categoryFilterStage === 3
    ) {
      var optionsDataInit = [];

      this.state.LookupData.forEach(element => {
        optionsDataInit.push({
          text: TitleCase(element[formControl.element_params.Fk]),
          value: element._id
        });
      });

      this.setState({
        selectedValue: d.value,
        optionsData: optionsDataInit,
        categoryFilterStage: 0
      });
      var lookupItem = _.filter(this.state.LookupData, { _id: d.value });

      var objItem = Object.assign({}, lookupItem[0]);
      objItem.parentId = this.props.element_id;
      objItem.repeatingFormUUID = this.props.repeatingFormUUID;

      this.props.onChange(
        this.props.repeatingForm,
        this.props.element_id,
        d.value
      );
      this.props.actions.updateLookup(objItem);
    } else {
      if (this.state.categoryFilterStage === 1) {
        var optionsDataInit = [];

        this.state.LookupData.forEach(element => {
          optionsDataInit.push({
            text: TitleCase(element[d.value]),
            value: TitleCase(element[d.value])
          });
        });
        optionsDataInit = _.uniqBy(optionsDataInit, "value");

        this.setState({
          filterCategory: d.value,
          optionsData: _.uniqBy(optionsDataInit, "value"),
          categoryFilterStage: 2
        });
      } else {
        lookupItem = _.filter(this.state.LookupData, {
          [this.state.filterCategory]: d.value
        });
        var optionsDataInit = [];

        lookupItem.forEach(element => {
          optionsDataInit.push({
            text: TitleCase(element[formControl.element_params.Fk]),
            value: element._id
          });
        });

        this.setState({
          filterCategory: "",
          optionsData: optionsDataInit,
          categoryFilterStage: 3
        });
      }
    }
  }

  handleChange(d, e) {
    this.setState({ visible: false, filterText: "" });
    var lookupItem = _.filter(this.state.LookupData, { Id: d });

    var objItem = Object.assign({}, lookupItem[0]);
    objItem.parentId = this.props.element_id;
    objItem.repeatingFormUUID = this.props.repeatingFormUUID;

    this.setState({ selectedValue: objItem.Name });

    this.props.onChange(this.props.repeatingForm, this.props.element_id, d);
    this.props.actions.updateLookup(objItem);
  }

  handleClear() {
    if (this.state.loading) {
      this.handleCancel();
    } else {
      this.setState({ selectedValue: "" });
      this.props.onChange(this.props.repeatingForm, this.props.element_id, "");
      this.props.actions.updateLookup({ parentId: this.props.element_id });
    }
  }

  handleTextChange(value) {
    this.setState({ selectedValue: value.target.value });
  }

  searchDirect() {
    const { ...formControl } = this.props;

    if (this.state.selectedValue.trim() === "") {
      return;
    }

    this.setState({ loading: true, cancel: false });
    this.forceUpdate();

    let x = this.state;
    let initialLookupData = [];

    var body = JSON.stringify({
      jsonrpc: "2.0",
      method: "datasource.findValuesByKey",
      params: {
        datasource_id: formControl.element_params.Ds,
        search_key: formControl.element_params.Fk,
        search_value: "%" + this.state.selectedValue + "%"
      },
      id: uuidv4()
    });

    var headers = {
      "x-rpc-api-version": "4.1.2",
      "x-rpc-auth-device": this.props.deviceId,
      "x-rpc-auth-username": this.props.username,
      "x-rpc-auth-password": this.props.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    return fetch(this.props.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(data => {
        if (!this.state.cancel) {
          if (data.result === null) {
            initialLookupData = [];
          } else {
            initialLookupData = data.result.data.map(lookup => {
              return lookup;
            });
          }

          var optionsDataInit = [];
          initialLookupData.forEach(element => {
            optionsDataInit.push({
              text: TitleCase(element[formControl.element_params.Fk]),
              value: element.Id
            });
          });

          this.setState({
            visible: true,
            loading: false,
            optionsData: optionsDataInit,
            LookupData: initialLookupData,
            gotLookup: true
          });
        }
      });
  }

  handleClose() {
    this.setState({ visible: false, loading: false, filterText: "" });
  }

  handleCancel() {
    this.setState({ cancel: true });
    this.forceUpdate();
    this.handleClose();
  }

  renderSearchButton() {
    if (this.state.loading) {
      return (
        <Button
          className="ui active button"
          style={{
            height: "40px",
            width: "46px",
            right: 0,
            position: "absolute"
          }}
          icon
          onClick={this.searchDirect.bind(this)}
        >
          <Loader
            active
            inverted
            style={{ position: "relative", top: "9px" }}
            size="small"
          />
        </Button>
      );
    }
    return (
      <Button
        className="ui active button"
        style={{
          height: "40px",
          right: 0,
          width: "46px",
          position: "absolute"
        }}
        icon
        onClick={this.searchDirect.bind(this)}
      >
        <Icon name="search" />
      </Button>
    );
  }

  handleFilter(e) {
    let fd = "";
    this.setState({ filterText: e.target.value });
  }

  getItems() {
    let items = [];
    let h = window.innerHeight * 0.85 - 70 - 44;

    let filterString = this.state.filterText;

    this.state.optionsData.forEach(element => {
      if (
        element.text.toLowerCase().indexOf(filterString.toLowerCase()) !== -1 ||
        filterString === ""
      ) {
        items.push(
          <div
            onClick={this.handleChange.bind(this, element.value)}
            className="rows"
          >
            {element.text}
          </div>
        );
      }
    });

    return (
      <div
        style={{
          width: "100%",
          height: h + "px",
          overflowY: "auto",
          borderBottomLeftRadius: "5px",
          borderBottomRightRadius: "5px",
          backgroundColor: "rgb(230, 230, 230)"
        }}
      >
        {items}
      </div>
    );
  }

  CategoryFilter() {
    var optionsDataInit = [];

    for (var key in this.state.LookupData[0]) {
      if (key !== "_id") {
        optionsDataInit.push({ text: TitleCase(key), value: key });
      }
    }

    this.setState({ categoryFilterStage: 1, optionsData: optionsDataInit });
  }

  renderSelect() {
    const { validate, error } = this.props;

    if (!this.state.salesforceType) {
      if (this.state.categoryFilterStage === 0) {
        if (validate && error) {
          return (
            <div
              style={{
                display: "inline-block",
                width: "100%",
                maxWidth: "500px"
              }}
            >
              <span style={{ display: "inline-block", width: "100%" }}>
                <Dropdown
                  style={{
                    border: "2px solid #e0b4b4",
                    color: "#9f3a38",
                    backgroundColor: "#fff6f6"
                  }}
                  icon={{
                    className: "testi",
                    name: "filter",
                    onClick: this.CategoryFilter.bind(this)
                  }}
                  loading={!this.state.gotLookup ? true : false}
                  minCharacters={0}
                  value={this.state.selectedValue}
                  placeholder="Search..."
                  onChange={this.handleChangeDD.bind(this)}
                  fluid
                  search
                  selection
                  options={this.state.optionsData}
                />
              </span>
              <span
                style={{
                  paddingRight: "5px",
                  paddingTop: "2px",
                  width: "100%",
                  textAlign: "right",
                  display: "inline-block"
                }}
              >
                <label
                  onClick={this.handleClear.bind(this)}
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  Clear
                </label>
              </span>
            </div>
          );
        }
        return (
          <div
            style={{
              display: "inline-block",
              width: "100%",
              maxWidth: "500px"
            }}
          >
            <span style={{ display: "inline-block", width: "100%" }}>
              <Dropdown
                icon={{
                  className: "testi",
                  name: "filter",
                  onClick: this.CategoryFilter.bind(this)
                }}
                loading={!this.state.gotLookup ? true : false}
                minCharacters={0}
                value={this.state.selectedValue}
                placeholder="Search..."
                onChange={this.handleChangeDD.bind(this)}
                fluid
                search
                selection
                options={this.state.optionsData}
              />
            </span>
            <span
              style={{
                paddingRight: "5px",
                paddingTop: "2px",
                width: "100%",
                textAlign: "right",
                display: "inline-block"
              }}
            >
              <label
                onClick={this.handleClear.bind(this)}
                style={{ textDecoration: "underline", cursor: "pointer" }}
              >
                Clear
              </label>
            </span>
          </div>
        );
      }
      if (validate && error) {
        return (
          <div
            style={{
              display: "inline-block",
              width: "100%",
              maxWidth: "500px"
            }}
          >
            <span style={{ display: "inline-block", width: "100%" }}>
              <Dropdown
                style={{
                  border: "2px solid #e0b4b4",
                  color: "#9f3a38",
                  backgroundColor: "#fff6f6"
                }}
                open={true}
                icon={{
                  className: "testi",
                  name: "filter",
                  onClick: this.CategoryFilter.bind(this)
                }}
                loading={!this.state.gotLookup ? true : false}
                minCharacters={0}
                value={this.state.selectedValue}
                placeholder="Search..."
                onChange={this.handleChangeDD.bind(this)}
                fluid
                search
                selection
                options={this.state.optionsData}
              />
            </span>
            <span
              style={{
                paddingRight: "5px",
                paddingTop: "2px",
                width: "100%",
                textAlign: "right",
                display: "inline-block"
              }}
            >
              <label
                onClick={this.handleClear.bind(this)}
                style={{ textDecoration: "underline", cursor: "pointer" }}
              >
                Clear
              </label>
            </span>
          </div>
        );
      }

      return (
        <div
          style={{ display: "inline-block", width: "100%", maxWidth: "500px" }}
        >
          <span style={{ display: "inline-block", width: "100%" }}>
            <Dropdown
              open={true}
              icon={{
                className: "testi",
                name: "filter",
                onClick: this.CategoryFilter.bind(this)
              }}
              loading={!this.state.gotLookup ? true : false}
              minCharacters={0}
              value={this.state.selectedValue}
              placeholder="Search..."
              onChange={this.handleChangeDD.bind(this)}
              fluid
              search
              selection
              options={this.state.optionsData}
            />
          </span>
          <span
            style={{
              paddingRight: "5px",
              paddingTop: "2px",
              width: "100%",
              textAlign: "right",
              display: "inline-block"
            }}
          >
            <label
              onClick={this.handleClear.bind(this)}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              Clear
            </label>
          </span>
        </div>
      );
    }

    return (
      <div style={{ maxWidth: "500px" }}>
        <form
          onSubmit={e => {
            this.searchDirect.bind(this);
            e.preventDefault();
          }}
        >
          <span
            style={{
              float: "left",
              width: "100%",
              position: "relative",
              paddingRight: "55px"
            }}
          >
            <input
              type="text"
              style={{ float: "left" }}
              placeholder={
                this.props.isConnected
                  ? ""
                  : "Offline: Address search not available"
              }
              value={this.props.isConnected ? this.state.selectedValue : ""}
              onChange={value => this.handleTextChange(value)}
            />
            {this.renderSearchButton()}
          </span>
        </form>
        <div
          style={{
            width: "100%",
            opacity: this.props.isConnected ? 1 : 0,
            textAlign: "right"
          }}
        >
          <span
            onClick={this.handleClear.bind(this)}
            style={{
              textDecorationLine: "underline",
              lineHeight: "30px",
              cursor: "pointer",
              color: this.props.storeColour.mainBgColor,
              marginRight: "60px"
            }}
          >
            {this.state.loading ? "Cancel" : "Clear"}
          </span>
        </div>
        <ReactModal
          isOpen={this.state.visible}
          style={customStyles}
          contentLabel="Example Modal"
          onRequestClose={() => {
            //alert('Modal has been closed.');
          }}
        >
          <div
            className="hrl"
            style={{
              width: "100%",
              height: "44px",
              lineHeight: "44px",
              backgroundColor: "white"
            }}
          >
            <div
              style={{
                paddingLeft: "0px",
                paddingTop: "5px",
                marginBottom: "0px",
                paddingBottom: "0px"
              }}
              className="ui form formControlItem"
            >
              <Form.Field>
                <input
                  type="text"
                  style={{ border: "none" }}
                  onChange={this.handleFilter.bind(this)}
                  value={this.state.filterText}
                  placeholder="Filter..."
                />
              </Form.Field>
            </div>
          </div>
          {this.getItems()}
          <div style={{ textAlign: "center", width: "100%", height: "50px" }}>
            <button
              onClick={this.handleClose.bind(this)}
              className="ui button submit"
              style={{ position: "relative", width: "100px", bottom: "-30px" }}
              role="button"
            >
              Cancel
            </button>
          </div>
        </ReactModal>
      </div>
    );
  }

  render() {
    const { element_prompt, element_value, ...formControl } = this.props;

    return (
      <div className="formControlItem">
        <Form.Field>
          <ControlTitle
            text={element_prompt}
            optional={formControl.element_optional === "1" ? true : false}
          ></ControlTitle>
          {this.renderSelect()}
        </Form.Field>
      </div>
    );
  }
}

LookupField.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  element_id: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  sessionId: PropTypes.string
};

const mapStateToProps = state => ({
  deviceId: state.informedWebApp.deviceId,
  username: state.informedWebApp.username,
  password: state.informedWebApp.password,
  datasource: state.forms.datasource,
  isConnected: state.informedWebApp.isConnected,
  api: state.informedWebApp.api,
  storeColour: state.informedWebApp.storeColour,
  lookupData: state.forms.lookupData
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LookupField);



// WEBPACK FOOTER //
// ./src/components/LookupField/index.js